module.exports = __webpack_public_path__ + "img/blue_economy_color.e6ce60bd.svg";